<script lang="ts">
    interface Props {
        sponsored: boolean | undefined;
        funderLegalName: string | undefined;
        advertiserLegalName: string | undefined;
    }

    let { sponsored, funderLegalName, advertiserLegalName }: Props = $props();
</script>

{#if sponsored}
    <ofc-sponsored-tag-v1
        data-secondary-action
        funder-legal-name={funderLegalName}
        advertiser-legal-name={advertiserLegalName}
    >
    </ofc-sponsored-tag-v1>
{/if}
